// src/lib/paymentMethod.js
// Single source of truth for cash-vs-credit; derive from the finance leg's account_from type,
// NOT payment_days (which is null on termless credit purchases). Audit 156.

// accountTypeById: account id -> account type/classification (case-insensitive). Accepts a
// plain object OR a Map. Unknown/missing account falls back to 'Cash' (matches Payment History).
export function paymentMethodOf(financeRow, accountTypeById) {
  if (!financeRow) return 'Cash';
  if (financeRow.subtype === 'supplier_credit') return 'Supplier Credit';
  if (financeRow.subtype === 'credit_note')     return 'Credit Note';
  const raw = accountTypeById instanceof Map
    ? accountTypeById.get(financeRow.account_from_id)
    : (accountTypeById || {})[financeRow.account_from_id];
  const t = typeof raw === 'string' ? raw.toLowerCase() : raw;
  if (t === 'bank')     return 'Bank';
  if (t === 'supplier') return 'Credit';   // AP-routed => owed, regardless of payment_days
  return 'Cash';                           // cash/bank leg => paid
}
